import {
  DateTextOperators,
  GenericTextOperators,
  NumberTextOperators,
  StringTextOperators,
} from '@mairistem/tools';
import _ from 'lodash';

export const getCondition = (operator: string) => {
  switch (operator) {
    case StringTextOperators.COMMENCE_PAR:
      return 'startWith';
    case StringTextOperators.CONTIENT:
      return 'contains';
    case StringTextOperators.TERMINE_PAR:
      return 'endWith';
    case NumberTextOperators.SUPERIEUR:
      return 'greater';
    case NumberTextOperators.INFERIEUR:
      return 'less';
    case NumberTextOperators.INFERIEUR_OU_EGAL:
      return 'greaterOrEqual';
    case NumberTextOperators.SUPERIEUR_OU_EGAL:
      return 'lessOrEqual';
    case DateTextOperators.APRES_LE:
      return 'after';
    case DateTextOperators.AVANT_LE:
      return 'before';
    case DateTextOperators.APRES_OU_EGALE:
      return 'since';
    case DateTextOperators.AVANT_OU_EGALE:
      return 'until';
    case DateTextOperators.EST_LE:
      return 'equal';
    case DateTextOperators.EST_PAS_LE:
      return 'not';
    case DateTextOperators.PARMIS_DATES:
      return 'in';
    case GenericTextOperators.RENSEIGNE:
      return 'isNotNull';
    case GenericTextOperators.PAS_RENSEIGNE:
      return 'isNull';
    case GenericTextOperators.EGALE_A:
      return 'equal';
    case GenericTextOperators.PAS_EGALE_A:
      return 'not';
    case GenericTextOperators.DANS_LISTE:
      return 'in';
  }

  return '';
};

export const formatFilters = (filters) =>
  _.reduce(
    filters,
    (result, filter) => ({
      ...result,
      [filter?.propertyName]: `${getCondition(filter?.textOperator)}(${filter?.value || ''})`,
    }),
    {},
  );
